var LandrEventType;
(function (LandrEventType) {
    LandrEventType["UserAvatarUpdate"] = "UserAvatarUpdate";
    LandrEventType["UserProfileCompletionUpdate"] = "UserProfileCompletionUpdate";
    LandrEventType["UserProfileWorkAvailabilityUpdate"] = "UserProfileWorkAvailabilityUpdate";
    LandrEventType["UserProfilePrivacyUpdate"] = "UserProfilePrivacyUpdate";
    LandrEventType["LockAutoRefresh"] = "LockAutoRefresh";
    LandrEventType["UnlockAutoRefresh"] = "UnlockAutoRefresh";
    LandrEventType["ReleaseWizardQuit"] = "ReleaseWizardQuit";
    LandrEventType["ReleaseWizardGoToStep"] = "ReleaseWizardGoToStep";
    LandrEventType["ReleaseWizardValidate"] = "ReleaseWizardValidate";
    LandrEventType["ReleaseWizardStepError"] = "ReleaseWizardStepError";
    LandrEventType["ReleaseWizardStepSuccess"] = "ReleaseWizardStepSuccess";
    LandrEventType["ReleaseWizardSubmit"] = "ReleaseWizardSubmit";
    LandrEventType["ReleaseWizardSaveAndQuit"] = "ReleaseWizardSaveAndQuit";
    LandrEventType["ReleaseWizardStartSave"] = "ReleaseWizardStartSave";
    LandrEventType["ReleaseWizardSaveEnd"] = "ReleaseWizardSaveEnd";
    LandrEventType["ReleaseWizardLegacyStateChange"] = "ReleaseWizardLegacyStateChange";
    LandrEventType["ReleaseWizardStartTrackUpload"] = "ReleaseWizardStartTrackUpload";
    LandrEventType["ReleaseWizardEndTrackUpload"] = "ReleaseWizardEndTrackUpload";
    LandrEventType["ReleaseWizardArtistsInUseUpdate"] = "ReleaseWizardArtistsInUseUpdate";
    LandrEventType["ReleaseWizardDisableNextAction"] = "ReleaseWizardDisableNextAction";
    LandrEventType["ReleaseWizardEnableNextAction"] = "ReleaseWizardEnableNextAction";
    // TODO when D_TracksStepV2 is rolled out, remove this event
    LandrEventType["ReleaseWizardArtistsErrors"] = "ReleaseWizardArtistsErrors";
    // TODO when D_TracksStepV2 is rolled out, remove this event
    LandrEventType["ReleaseWizardArtistsDisabled"] = "ReleaseWizardArtistsDisabled";
    LandrEventType["SessionsReservationRoomsChange"] = "SessionsReservationRoomsChange";
    LandrEventType["ReleaseWizardSubmitPermissionsChange"] = "ReleaseWizardSubmitPermissionsChange";
})(LandrEventType || (LandrEventType = {}));

export { LandrEventType };
